import { defineStore } from 'pinia';
import { NotificationProps, notificationEvents } from '@/interfaces';
import { useIntervalFn, useEventBus, Pausable, UseEventBusReturn } from "@vueuse/core"

interface Notification {
  id: number
  duration: number /** Display duration in miliseconds */
  controls: Pausable
  eventBus: UseEventBusReturn<notificationEvents, any> /** Inform button click, close */
  props: NotificationProps
}

interface Notifications {
  [id: number]: Notification
}

const useClaimStore = defineStore("NotificationStore", {
  state: () => {
    return {
      counter: 0,
      notifications: {} as Notifications,
    }
  },
  actions: {
    emitNotification(props: NotificationProps, duration = 3000) {
      const id = this.counter++;
      this.notifications[id] = {
        id,
        props,
        duration,
        eventBus: useEventBus<notificationEvents>(`notification-${id}`),
        controls: useIntervalFn(() => duration !== -1 ? this.decreaseDuration(id, 100) : null
        , 100) as any // TS bug
      };

      return this.notifications[id]
    },
    closeNotification(id: number) {
      this.notifications[id].eventBus.emit('close');
      this.notifications[id].eventBus.reset();
      // this.notifications[id].controls.isActive = false;
      delete this.notifications[id];
    },
    decreaseDuration(id: number, ms = 100) {
      if (!this.notifications[id]) return false;
      else if (this.notifications[id].duration <= 0) return this.closeNotification(id);
      
      this.notifications[id].duration -= ms;
    },
    clear() {
      this.notifications = [];
    }
  }
});

export default useClaimStore;